 <div class="form-field-header">
    <div class="form-field-title-container">
        <span class="form-field-title">Integration URL</span>
            <div
                class="form-field-info infoicon"
                matTooltip="The URL of the SCIM Server to use when configuring your IDP to sync identities to Ziti."
                matTooltipPosition="above"
            ></div>
        </div>
</div>
<div class="copy-link-container" (click)="copyIntegrationUrl()">
    <span class="read-only" (click)="copyIntegrationUrl()">{{baseUrl}}{{integrationKey}}{{pathEnd}}</span>
    <div class="copy-button" (click)="copyIntegrationUrl()"></div>
</div>